<ng-container *translateBlock="let t">
  @if (formData.formGroup) {
    <div class="input-wrapper"
         [formGroup]="formData.formGroup">
      @if (isLoading) {
        @if (formData.label) {
          <label [for]="formData.id">
            @if (formData.iconLeft) {
              <span class="material-symbols-rounded icon-left">
              {{ formData.iconLeft }}
            </span>
            }

            {{ formData.isTranslated ? t(formData.label) : formData.label }}
          </label>
        }

        <p-skeleton height="35px"
                    class="mb-2" />
      } @else {
        @if (formData.label) {
          <label [for]="formData.id">
            @if (formData.iconLeft) {
              <span class="material-symbols-rounded icon-left">
            {{ formData.iconLeft }}
          </span>
            }

            {{ formData.isTranslated ? t(formData.label) : formData.label }}
          </label>
        }

        <p-selectbutton [formControlName]="formData.id"
                        [options]="formData.options"
                        size="small"
                        (onChange)="onSelectChange($event)">
          <ng-template #item
                       let-item>
          <span [title]="item.tooltip || ''">
            @if (item.iconLeft) {
              <span class="material-symbols-rounded icon-left">
              {{ item.iconLeft }}
            </span>
            }

            @if (item.label) {
              {{ formData.isTranslated ? t(item.label) : item.label }}
            }

            @if (item.iconRight) {
              <span class="material-symbols-rounded icon-right">
              {{ item.iconRight }}
            </span>
            }
          </span>
          </ng-template>
        </p-selectbutton>
      }
    </div>
  }
</ng-container>
